module.exports = __webpack_public_path__ + "img/groups_mail.18f64828.png";